import React from "react";
import useAuth from "../../hooks/useAuth";
import { CheckCircle, TaskStatusIcon } from "./TaskDetailPane";
import { dueState, formatDueDate, formatMinutes, initials } from "./taskUtils";
import { RepeatBadge } from "./RepeatField";

export function TaskListHead() {
  return (
    <div className="tk-list-head" role="row">
      <span role="columnheader">Task name</span>
      <span role="columnheader">Due date</span>
      <span role="columnheader">Logged</span>
      <span role="columnheader">Projects</span>
      <span role="columnheader">Assignee</span>
    </div>
  );
}

export function NewTaskRow({
  value,
  onChange,
  onSubmit,
  onCancel,
  placeholder,
}) {
  return (
    <div className="tk-row tk-row-new" role="row">
      <span className="tk-row-name">
        <CheckCircle checked={false} onToggle={() => {}} />
        <input
          autoFocus
          className="tk-row-input"
          placeholder={placeholder || "Write a task name"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.nativeEvent.isComposing) return;
            if (e.key === "Enter") onSubmit();
            if (e.key === "Escape") onCancel();
          }}
          onBlur={() => !value.trim() && onCancel()}
        />
      </span>
    </div>
  );
}

export function TaskRow({ task, selected, onOpen, onToggle }) {
  const { user } = useAuth();
  const due = dueState(task.dueDate, task.completed);
  return (
    <div
      role="row"
      tabIndex={0}
      className={`tk-row ${selected ? "selected" : ""}`.trim()}
      onClick={() => onOpen(task.id)}
      onKeyDown={(e) => e.key === "Enter" && onOpen(task.id)}
    >
      <span className="tk-row-name" role="cell">
        <TaskStatusIcon task={task} onToggle={() => onToggle(task)} />
        <span className="tk-row-title">
          <span className={task.completed ? "tk-done-text" : ""}>
            {task.name}
          </span>
          {task.parentTask && (
            <span className="tk-row-meta">↳ {task.parentTask.name}</span>
          )}
        </span>
        {task.subtaskCount > 0 && (
          <span className="tk-pill" title="Subtasks completed">
            {task.completedSubtaskCount}/{task.subtaskCount}
          </span>
        )}
        {task.waitingOnCount > 0 && !task.completed && (
          <span className="tk-pill tk-pill-warn" title="Waiting on other tasks">
            Waiting on {task.waitingOnCount}
          </span>
        )}
      </span>
      <span role="cell" className={`tk-due ${due ? `due-${due}` : ""}`}>
        {formatDueDate(task.dueDate)}
        {task.recurrence && <RepeatBadge rule={task.recurrence} />}
      </span>
      <span role="cell" className="tk-row-time">
        {task.minutesLogged > 0 ? formatMinutes(task.minutesLogged) : ""}
      </span>
      <span role="cell" className="tk-row-projects">
        {task.projects.map((p) => (
          <span key={p.id} className="tk-chip tk-chip-static">
            {p.name}
          </span>
        ))}
      </span>
      <span role="cell">
        {task.assignee && (
          <span className="tk-assignee">
            <span className="tk-avatar tk-avatar-sm">
              {initials(task.assignee.name)}
            </span>
            <span className="tk-assignee-name">
              {task.assignee.id === user?.id ? "Me" : task.assignee.name}
            </span>
          </span>
        )}
      </span>
    </div>
  );
}
